import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import * as styles from './ModalBox.css';
import Icon from '../../components/Icon/Icon';
import IconClose from '../../assets/svg/closeIconNew.svg';
import Button from '../../components/Button';
import ScrollLockHOCFactory from '../../hoc/ScrollLockHOC/ScrollLockHOC';
import { dt } from '../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);
/**
 * ModalBox component to display Modal based on HTML supplied by user
 * <ModalBox showModal={modalOpen} onClose={close} >
 *   <div>
 *      Modal
 *   </div>
 * </ModalBox>
 */

const successIcon = (<svg width="48" height="48" viewBox="0 0 40 40">
    <path id="success-icon" d="M11.59 14.07L25.229.083l4.545 4.662-18.182 18.649L.227 11.738l4.545-4.662z" transform="translate(5 7.5)" />
</svg>);
const warningIcon = (<svg width="48" height="48" viewBox="0 0 40 40">
    <path transform="translate(5 5)" fill="#fff" id="warning-icon-a" d="M13.75.625l-13.125 30h26.25z" />
    <path transform="translate(5 5)" id="warning-icon-c" d="M31.072 25.159L17.177-.043a2.47 2.47 0 0 0-2.13-1.207c-.876 0-1.556.462-1.995 1.205L-.85 25.138c-.437.744-.567 1.69-.13 2.435.44.745 1.302 1.177 2.177 1.177H28.62c1.067 0 2.152-.457 2.593-1.204.434-.743.293-1.643-.142-2.387zM12.776 7.5h4.675v10h-4.675v-10zm0 16.25c0-1.38 1.047-2.5 2.338-2.5 1.29 0 2.337 1.12 2.337 2.5s-1.046 2.5-2.337 2.5c-1.291 0-2.338-1.12-2.338-2.5z" />
</svg>);
const errorIcon = (<svg viewBox="0 0 40 40" width="48" height="48">
    <path fillRule="evenodd" d="M34.116 12.826L27.052 5.86c-.54-.544-1.24-.86-2.005-.86l-10.126.017c-.721 0-1.426.293-1.936.804L6.079 12.63A3.683 3.683 0 005 15.245v9.69c0 .805.311 1.56.878 2.128l6.983 7.01a3.128 3.128 0 002.233.927h9.796c.854 0 1.655-.334 2.258-.94l6.742-6.764A3.781 3.781 0 0035 24.608v-9.642a3.01 3.01 0 00-.884-2.14zm-16.258 9.316h4.284V11.428h-4.284v10.714zM20 28.572a2.143 2.143 0 110-4.286 2.143 2.143 0 010 4.286z" />
</svg>);
const lockIcon = (
    <svg
        width="22"
        height="22"
        viewBox="0 5 40 40"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>5EA0826A-68F0-4C29-A591-BCF4DC17EA64</title>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h48v48H0z" />
            <g transform="translate(14 11)" fill="#FFF">
                <rect y="10" width="20" height="16" rx="2" />
                <path
                    d="M6 7.006v9.988A4.004 4.004 0 0 0 10 21c2.204 0 4-1.796 4-4.006V7.006A4.004 4.004 0 0 0 10 3C7.796 3 6 4.796 6 7.006zm-3 0C3 3.136 6.142 0 10 0c3.866 0 7 3.138 7 7.006v9.988C17 20.864 13.858 24 10 24c-3.866 0-7-3.138-7-7.006V7.006z"
                    fillRule="nonzero"
                />
            </g>
        </g>
    </svg>
);

export class ModalBox extends Component {

    /*
     * Supported PropTypes for Modal components
     * @type {Object}
     */
    static propTypes = {

        /**
         * Required field to close or open Modal
         * @type {[type]}
         * showModal: PropTypes.bool,
         */
        showModal: PropTypes.bool.isRequired,

        /**
         * On close call back event for Modal
         * @type {[type]}
         * onClose: PropTypes.func,
         */
        onClose: PropTypes.func.isRequired,

        /**
         * HTML wrapped inside Modal html
         * @type {[type]}
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
        ]),

        /**
         * Custom Class Name for modal Wrapper
         * @type {[type]}
         */
        modalTheme: PropTypes.string,

        /**
         * Custom Class Name for modal content
         * @type {[type]}
         */
        modalContentTheme: PropTypes.string,

        /**
         * Custom Class Name for modal overlay
         * @type {[type]}
         */
        modalOverlayTheme: PropTypes.string,

        /**
         * Custom Class Name for modal Button
         * @type {[type]}
         */
         modalCTATheme: PropTypes.string,

        /**
         * Custom Class Name for modal overlay
         * @type {[type]}
         */
        modalBlockTheme: PropTypes.string,

        /**
         * Custom Class Name for modal overlay
         * @type {[type]}
         */
         modalHeaderTheme: PropTypes.string,

        /**
         * Custom Class Name for modal title
         * @type {[type]}
         */
        modalTitleTheme: PropTypes.string,

        /**
         * Custom Class Name for modal subtitle
         * @type {[type]}
         */
        modalSubTitleTheme: PropTypes.string,

        /**
         * Custom Class Name for modal subtitle
         * @type {[type]}
         */
         modalHeaderIconTheme: PropTypes.string,

        /**
         * Switch to display default header
         * @type {[type]}
         */
        defaultHeader: PropTypes.bool,

        /**
         * Object with following boolean props. They are
         * exclusive to each other.
         *
         * isMobile
         * isTablet
         * isDesktop
         */
        deviceType: PropTypes.object, // eslint-disable-line

        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */
        automationId: PropTypes.string,

        /** Title and Subtitle if needed * */
        title: PropTypes.string,
        subTitle: PropTypes.string,

        /**
         * Switch to display close button
        */
        defaultCloseBtn: PropTypes.bool,

        /**
         * Specific automationIDs for QA usage
        */
        wrapperAutomationId: PropTypes.string,
        iconAutomationId: PropTypes.string,
        titleAutomationId: PropTypes.string,
        subTitleAutomationId: PropTypes.string,
        overlayAutomationId: PropTypes.string,
        customOverlayStyle: PropTypes.object,
        /**
         * renderingthrough Portal
         */
        renderModalToBody: PropTypes.bool,
        /**
         * Icon to display above the title
         */
        iconType: PropTypes.string,
        /**
         * ctaBtns to show at the bottom of modal
         */
        ctaBtns: PropTypes.shape({
            title: PropTypes.string,
            buttonType: PropTypes.string,
            automationId: PropTypes.string,
            size: PropTypes.string,
            onClickAction: PropTypes.func,
            btnIconType: PropTypes.string,
            isDisabled: PropTypes.bool,
        }),

        modalCTAList: PropTypes.string,
    };

    /**
     * Initializing  onclose props
     */
    static defaultProps = {
        modalTheme: '',
        children: '',
        defaultHeader: false,
        automationId: '',
        title: '',
        subTitle: '',
        defaultCloseBtn: true,
        modalContentTheme: '',
        modalOverlayTheme: '',
        customOverlayStyle: {},
        modalCTATheme:'',
        modalBlockTheme: '',
        modalHeaderTheme:'',
        modalTitleTheme: '',
        modalSubTitleTheme: '',
        modalHeaderIconTheme:'',
        deviceType: {},
        wrapperAutomationId: '',
        titleAutomationId: '',
        subTitleAutomationId: '',
        renderModalToBody: false,
        overlayAutomationId: '',
        iconAutomationId: '',
        iconType: '',
        ctaBtns: [],
        modalCTAList: '',
    };

    /**
     * Function to trigger onclose callback function registered
     * by app components
     */
    closeModal(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onClose();
    }

    renderCTAs() {
        const { ctaBtns,modalCTATheme, modalCTAList } = this.props;
        const buttons = ctaBtns.map(cta => (
            <div className={`${dt(['text-center','mt-4'])} ${cx(modalCTAList,'modalCTA')}`}>
                <Button
                    automationId={cta.automationId}
                    buttonType={cta.buttonType}
                    size={cta.size}
                    onClick={cta.onClickAction}
                    className={`${cx('col12')} ${dt(['w-full', 'mx-auto', 'lg:max-w-[200px]'])}`}
                    isDisabled={cta.isDisabled}
                >
                    {cta.btnIconType === 'lock' &&
                        <span className={`${dt(['mr-1'])} ${cx('btnIcon')}`}>
                            {lockIcon}
                        </span>
                    }
                    {cta.title}
                </Button>
            </div>
        ));

        return (
            <div className={`${dt(['mt-6', 'mdOnly:mx-auto', 'mdOnly:w-[90%]', 'smOnly:w-full'])} ${cx('modalCTAWrapper',modalCTATheme)}`}>
                {buttons}
            </div>
        );
    }

    renderHeaderIcon() {
        const { iconType, iconAutomationId, modalHeaderIconTheme } = this.props;

        return (
            <div className={`${dt(['text-center', 'mb-2'])} ${cx('modalHeaderIcon',modalHeaderIconTheme )}`} data-automation-id={iconAutomationId}>
                {/* <SuccessCheck /> */}
                {iconType === 'success' &&
                    <div className={`${cx('success')} ${dt(['inline-block', 'mr-2'])}`}>
                        {successIcon}
                    </div>
                }
                {iconType === 'warning' &&
                    <div className={`${cx('warning')} ${dt(['inline-block', 'mr-2'])}`}>
                        {warningIcon}
                    </div>
                }
                {iconType === 'error' &&
                    <div className={`${cx('error')} ${dt(['inline-block', 'mr-2'])}`}>
                        {errorIcon}
                    </div>
                }
            </div>
        );
    }

    render() {
        const {
            showModal,
            children,
            modalTheme,
            defaultHeader,
            automationId,
            title,
            subTitle,
            modalContentTheme,
            defaultCloseBtn,
            modalOverlayTheme,
            customOverlayStyle,
            modalBlockTheme,
            modalHeaderTheme,
            modalTitleTheme,
            modalSubTitleTheme,
            wrapperAutomationId,
            titleAutomationId,
            subTitleAutomationId,
            overlayAutomationId,
            renderModalToBody,
            iconType,
            ctaBtns,
            inputClassName
        } = this.props;

        const modalWrapperStyles = dt([
            'sm:p-6',
            'smOnly:!rounded-none',
            'smOnly:w-full',
            'smOnly:h-full',
            'lg:w-[440px]',
            'absolute',
            'top-1/2',
            'left-1/2',
            '-translate-y-1/2',
            '-translate-x-1/2',
            'z-[100]',
            'bg-white',
            'rounded-md',
            'sm:min-w-[150px]',
            'md:w-[474px]',
            'lg:min-w-[608px]',
            'max-w-[688px]',
            'lg:[w-3/5]',
            'overflow-visible',
            'not-italic',
            'max-h-[90vh]',
        ]);
        const modalHtml = (
            <div style={customOverlayStyle} data-automation-id={overlayAutomationId} className={`${dt(['w-full','h-full','fixed','top-0','left-0','sm:z-[99]','bg-overlay-60'])} ${cx('modalOverlay', modalOverlayTheme)}`}>
                <div className={`${modalWrapperStyles} ${cx('modalWrapper', modalTheme, inputClassName)}`} data-automation-id={wrapperAutomationId}>
                    <div className={`${dt(['smOnly:h-full'])} ${cx('modalBlock', modalBlockTheme)}`}>
                        <div className={`${dt(['flex'])} ${cx(modalHeaderTheme)}`}>
                            {iconType && this.renderHeaderIcon()}
                            {defaultHeader ?
                                <div className={`${dt([defaultCloseBtn ? 'sm:w-[calc(100%-48px)]' : 'w-full', 'text-center'])} ${styles.modalHeader}`}>
                                    <h2 className={`${dt(['text-black','text-normal','font-open-sans-semibold','leading-tight', 'empty:hidden'])} ${cx('modalTitle', modalTitleTheme)}`} data-automation-id={titleAutomationId}>
                                        {title}
                                    </h2>
                                    <h4 className={`${dt(['text-black','font-open-sans','text-small','font-normal','leading-snug','mt-2', 'empty:hidden'])} ${cx('modalSubTitle', modalSubTitleTheme)}`} data-automation-id={subTitleAutomationId}>
                                        {subTitle}
                                    </h4>
                                </div> : ''}
                            {defaultCloseBtn ? <button
                                className={`${dt(['cursor-pointer','p-0','text-center','my-0','ml-auto','lg:w-8','lg:h-8','smMd:w-7','smMd:h-7','text-black', 'float-right',])} ${styles.crossBar}`}
                                onClick={e => this.closeModal(e)}
                                data-automation-id="modal-button"
                            >
                                <Icon
                                    type="button" iconType="svg" width="28px" height="28px" viewBox="0 0 28 28"
                                    automationId={`modal-icon-${automationId}`}>
                                    <IconClose/>
                                </Icon>
                            </button> : ''}
                        </div>
                        <div className={`${dt(['font-open-sans', 'clear-both', 'text-black','text-small','pt-4', 'lg:max-h-[calc(100vh-150px)]', 'smMd:max-h-[calc(100vh-160px)]', 'overflow-y-auto', 'empty:hidden'])} ${cx('modalContent', modalContentTheme)}`} data-automation-id="modal-content">
                            {children}
                        </div>
                        {ctaBtns.length > 0 && this.renderCTAs()}
                    </div>
                </div>
            </div>
        );


        if (showModal) {
            return renderModalToBody ? ReactDOM.createPortal(modalHtml, document.body) : modalHtml;
        }
        return null;
    }
}

export default ScrollLockHOCFactory('showModal')(ModalBox);
